import { render, staticRenderFns } from "./addedit-folder.vue?vue&type=template&id=16b83f8d&scoped=true"
import script from "./addedit-folder.vue?vue&type=script&lang=js"
export * from "./addedit-folder.vue?vue&type=script&lang=js"
import style0 from "./addedit-folder.vue?vue&type=style&index=0&id=16b83f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b83f8d",
  null
  
)

export default component.exports